export default function (mutation, busyVar = 'deleteBusy')
{
    return async function(ok)
    {
        this[busyVar] = true;

        try
        {
            await this.$apollo.mutate(
                {
                    mutation,
                    variables: { id: this.objToDelete.id }
                }
            );
        }
        catch (e)
        {
            console.error(e);
        }
        finally
        {
            this[busyVar] = false;
            ok();
        }
    }
}